<template>
  <div class="uid-token">
    <img
      class="uid-token-game-logo"
      :src="gameId ? gameList[gameId] && gameList[gameId].PIC_URL : ''"
      alt="gameLogo"
      v-if="gameId && gameList[gameId] && gameList[gameId].PIC_URL"
    />
    <p class="uid-token-title">
      {{ letter.uidToken
      }}<span class="ask" @click="showIntroTips()">
        <svg
          class="bi bi-question-circle-fill"
          fill="#666"
          height="2.6vh"
          viewBox="0 0 16 16"
          width="2.6vh"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"
          />
        </svg>
      </span>
    </p>
    <p class="uid-token-input-label">{{ letter.uidInputUid }}</p>
    <!-- <input
      v-model="uid"
      class="uid-token-input-box"
      :placeholder="letter.uidInputUid"
    /> -->
    <label class="input-box box">
      <input
        v-model="uid"
        class="input"
        type="text"
        inputmode="numeric"
        :placeholder="letter.uidInputUid"
        @compositionstart="onUidCompositionStart"
        @compositionend="onUidCompositionEnd"
        @input="onUidInput"
      />
    </label>
    <p class="uid-token-input-label">{{ letter.uidInputToken }}</p>
    <div class="uid-token-dynamic-code">
      <input
        v-for="(item, index) in dynamicCodeInput"
        v-model="item.num"
        :id="'dynamicCodeInput' + index"
        :key="index"
        @input="inputFinish(index)"
        @focus="adjust(index)"
        @keydown="inputDirection(index)"
        maxlength="1"
        class="uid-token-input-box"
        type="text"
      />
    </div>
    <p class="uid-token-input-label" v-if="needVerticationCode">
      {{ letter.uidInputCode }}
    </p>
    <div class="uid-token-verification-code" v-if="needVerticationCode">
      <input
        v-model="verificationCode"
        class="uid-token-input-box verification"
        :placeholder="letter.uidInputCode"
      />
      <div class="verification-code-box">
        <img
          class="verification-img"
          :src="verificationImgSrc"
          alt="verificationImage"
        />
        <span
          class="refresh-ico"
          :class="{ refresh: refreshStatus }"
          @click="refreshVerificationImg"
        ></span>
      </div>
    </div>
    <a
      type="fillLightVh"
      class="btn uid-token-login-btn j-uid-token-login-btn"
      href="javascript:void(0);"
      @click="uidTokenLogin"
    >
      <span>{{ letter.login }}</span>
      <i v-show="loading" class="loading light" style="margin-left: 1vh"></i>
    </a>
    <uid-token-guide-popup-auto
      v-show="showGuide"
      @hidePopup="showGuide = false"
      :guidePopLink="guidePopLink"
    ></uid-token-guide-popup-auto>
  </div>
</template>

<script type="text/javascript">
import login from '../../mixins/Login.js';
import uidNumericInput from '@mixins/uidNumericInput';
import globalConfig from '../../utiles/globalConfig.js';
import { reportActivityPoint } from '../../utiles/webLogin/activityPoint.js';
import UidTokenGuidePopupAuto from './UidTokenGuidePopupAuto.vue';
import {
  GO_UID_TOKEN_LOGIN,
  paramForward,
  CHECK_NEED_VERIFICATION_CODE
} from '../../store/web/login.js';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
const mainHost = globalConfig.getMainHost();

export default {
  name: 'uidTokenLogin',
  mixins: [login, uidNumericInput],
  data() {
    return {
      uid: '',
      dynamicCode: '',
      activeInput: 0,
      dynamicCodeInput: [{ num: '' }, { num: '' }, { num: '' }, { num: '' }],
      verificationCode: '',
      verificationImgSrc: `//gpassport.${mainHost}/center/ajax/get_code`,
      canUidTokenLogin: true,
      showGuide: false,
      needVerticationCode: false,
      refreshStatus: false
    };
  },
  computed: {
    gameList() {
      return this.$store.state.gameList;
    },
    gameId() {
      return this.$store.state.gameId;
    },
    guidePopLink() {
      return getGlobalGetGotoLink({
        link: `//auto-page.octlib.com/otp_guide/?v=20250110&gameId=${this.$store.state.gameId}&language=${this.lang}&host=${mainHost}`
      });
    },
    lang() {
      return this.$store.state.lang;
    }
  },
  created() {
    this.checkNeedVerificationCode();
  },
  methods: {
    showIntroTips() {
      this.showGuide = true;
    },
    adjust(index) {
      let dom = document.getElementById('dynamicCodeInput' + this.activeInput);
      if (this.activeInput == 4) {
        document.getElementById('dynamicCodeInput3').focus();
        return;
      }
      if (index != this.activeInput && dom) {
        dom.focus();
      }
    },
    inputDirection(index) {
      let val = this.dynamicCodeInput[index].num;
      if (event.keyCode == 8 && val == '') {
        let dom = document.getElementById('dynamicCodeInput' + (index - 1));
        this.activeInput = index - 1;
        dom && dom.focus();
      }

      if (event.keyCode != 8 && val != '') {
        let dom = document.getElementById('dynamicCodeInput' + (index + 1));
        this.activeInput = index + 1;
        dom && dom.focus();
      }
    },
    inputFinish(index) {
      let val = String(this.dynamicCodeInput[index].num).replace(/\D/g, '');
      if (!val) {
        this.dynamicCodeInput[index].num = '';
        return;
      }
      this.activeInput = val ? index + 1 : index;
      let dom = document.getElementById('dynamicCodeInput' + this.activeInput);
      dom && dom.focus();
      if (index == this.dynamicCodeInput.length - 1) {
        let code = this.dynamicCodeInput.map(item => item.num).join('');
        if (code.length == 4) {
          this.dynamicCode = code;
        }
      }
    },
    refreshVerificationImg() {
      this.verificationImgSrc = `//gpassport.${mainHost}/center/ajax/get_code?${this.randomNumber(
        1,
        100000
      )}`;
      this.verificationCode = '';
      this.refreshStatus = true;
      setTimeout(() => {
        this.refreshStatus = false;
      }, 1000);
    },
    checkInputValid() {
      if (!this.uid) {
        alert(this.letter.uidInputUid);
        return false;
      }

      if (!this.dynamicCode) {
        alert(this.letter.uidInputToken);
        return false;
      }

      if (!this.verificationCode && this.needVerticationCode) {
        alert(this.letter.uidInputCode);
        return false;
      }

      return true;
    },
    resetDynamicCodeInput() {
      this.dynamicCodeInput.forEach(item => {
        item.num = '';
      });
      this.dynamicCode = '';
      this.activeInput = 0;
    },
    uidTokenLogin() {
      if (!this.checkInputValid()) {
        this.$clearDisable('uid-token-login-in-btn');
        return;
      }
      if (this.canUidTokenLogin) {
        this.canUidTokenLogin = false;
        this.loading = true;
        reportActivityPoint('login_click', {
          gameId: this.gameId,
          eventType: 'uid_token_login',
          eventValue: { with_ckcode: this.needVerticationCode ? 1 : 0 }
        });
        this.$store
          .dispatch(GO_UID_TOKEN_LOGIN, {
            uid: this.uid,
            token: this.dynamicCode,
            ckcode: this.verificationCode,
            gameId: this.gameId,
            packageName: globalConfig.getHrefParam('packageName')
          })
          .then(res => {
            if (res.result) {
              reportActivityPoint('login_success', {
                gameId: this.gameId,
                eventType: 'uid_token_login'
              });
              window.location.href = globalConfig.hrefAddParam(
                paramForward,
                'gameId',
                this.gameId
              );
              this.loading = false;
              this.$clearDisable('uid-token-login-in-btn');
            } else {
              reportActivityPoint('login_fail', {
                gameId: this.gameId,
                eventType: 'uid_token_login',
                eventValue: { msg: String(res?.msg || '') }
              });
              this.loading = false;
              this.canUidTokenLogin = true;
              this.$clearDisable('uid-token-login-in-btn');
              this.checkNeedVerificationCode();
              this.resetDynamicCodeInput();
              alert(res.msg);
            }
          });
      }
    },
    checkNeedVerificationCode() {
      this.$store.dispatch(CHECK_NEED_VERIFICATION_CODE).then(res => {
        if (res.result) {
          if (res.data && +res.data.NEED_CKCODE === 1) {
            this.needVerticationCode = true;
            this.refreshVerificationImg();
          } else {
            this.needVerticationCode = false;
          }
        } else {
          alert(res.msg);
        }
      });
    },
    randomNumber(min, max) {
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      const number = randomBuffer[0] / (0xffffffff + 1);
      return Math.floor(number * (max - min) + min);
    }
  },
  components: {
    UidTokenGuidePopupAuto
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base.scss';
@import '../../assets/scss/webLogin-v3.scss';
</style>
